import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function AboutPage() {
  return <div className="w-full max-w-4xl mx-auto py-12 px-4 animate-in fade-in duration-500" data-id="element-118">
      <div className="text-center mb-16" data-id="element-119">
        <div className="inline-flex items-center justify-center p-3 bg-[#4db8a4]/10 rounded-full mb-6" data-id="element-120">
          <ShieldCheckIcon className="h-8 w-8 text-[#4db8a4]" data-id="element-121" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-6" data-id="element-122">
          About ProvenanceOne
        </h1>
        <p className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-123">
          We are building the trust layer for the next generation of enterprise
          software.
        </p>
      </div>

      <div className="space-y-16" data-id="element-124">
        <section className="bg-white border border-gray-200 rounded-2xl p-8 md:p-12 shadow-sm" data-id="element-125">
          <h2 className="text-3xl font-bold text-[#1e3a5f] mb-6" data-id="element-126">
            Our Mission
          </h2>
          <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-127">
            <p className="mb-4" data-id="element-128">
              At ProvenanceOne, we believe that the transition to agentic AI is
              the most significant architectural shift in enterprise software
              since the move to the cloud. However, this shift introduces
              unprecedented security and compliance challenges.
            </p>
            <p className="mb-4" data-id="element-129">
              When AI agents act autonomously on behalf of humans, traditional
              identity and access management paradigms break down. Open-ended
              write access is too dangerous, and requiring human approval for
              every action defeats the purpose of autonomy.
            </p>
            <p className="font-semibold text-[#1e3a5f]" data-id="element-130">
              Our mission is to solve this dilemma by providing deterministic,
              auditable, and enforceable control over AI agents, enabling
              enterprises to safely scale AI in highly regulated environments.
            </p>
          </div>
        </section>

        <section className="grid md:grid-cols-2 gap-8" data-id="element-131">
          <div className="bg-[#e8f7f4] rounded-2xl p-8 border border-[#4db8a4]/30" data-id="element-132">
            <h3 className="text-2xl font-bold text-[#1e3a5f] mb-4" data-id="element-133">
              Why MCPGuard?
            </h3>
            <p className="text-[#3a5878] leading-relaxed" data-id="element-134">
              We built MCPGuard because we saw enterprises investing heavily in
              AI capabilities, only to have those projects stalled in the lab by
              security and compliance teams. MCPGuard is the bridge that allows
              AI to move into production safely, providing the paper trail and
              policy enforcement that regulators and auditors demand.
            </p>
          </div>

          <div className="bg-[#1e3a5f] rounded-2xl p-8 text-white" data-id="element-135">
            <h3 className="text-2xl font-bold mb-4" data-id="element-136">Join Us</h3>
            <p className="text-white/80 leading-relaxed mb-6" data-id="element-137">
              We are a team of security engineers, identity experts, and AI
              practitioners building the future of enterprise security. If
              you're passionate about solving the hardest problems in AI
              governance and want to help shape what comes next, we'd love to
              hear from you.
            </p>
            <a href="#/early-access" className="inline-flex items-center font-medium text-[#4db8a4] hover:text-white transition-colors" data-id="element-138">
              Contact us &rarr;
            </a>
          </div>
        </section>
      </div>
    </div>;
}